import React, { Fragment } from 'react'
import { Link, RouteComponentProps } from 'react-router-dom'
import { Card, Heading } from '@scentregroup/ui'
import { useCountryContext, useEvolvedContext } from '../../context'
import withContentPage from '../../containers/with-content-page'
import withNationalHomepage from '../../containers/with-national-homepage'
import withCentreSelector from '../../containers/with-centre-selector'
import withGiftCards from '../../containers/with-gift-cards'
import Markdown from '../../components/markdown'
import TableOfContents from '../../components/table-of-contents'
import UnifiedHeader from '../../components/unified-header'
import NationalFooter from '../../components/national-footer'
import { UniversalFooter } from '../../components/universal-footer'
import PageLanding from '../../components/page-landing'
import { MetaData } from '../../../types/meta-data'
import {
  TermsModule,
  MetaData as ContentPageMetaData,
  isTermsModule,
} from '../../../types/content-page'
import { titleFromContentPage } from '../../helpers/title-from-content-page'
import { getCountry } from '../../helpers/get-country'
import pagesHoc from '../pages-hoc'
import {
  NationalStaticData,
  useUniversalHeader,
} from '../../hub-components/universal-header'
import style from './index.module.scss'

interface ContentPageProps {
  modules: TermsModule[]
  metaData: ContentPageMetaData
  centres?: any
  giftCards?: any
  nationalExperienceNavLinks?: any
  nationalNavLinks?: any
  nationalHeaderData: NationalStaticData
}

const ContentPage: React.FunctionComponent<ContentPageProps> = ({
  metaData,
  modules,
  nationalHeaderData,
}) => {
  const country = useCountryContext()
  const isEvolved = useEvolvedContext()
  const termsModules = modules.filter(isTermsModule)

  const [Header, setHeaderNavigationPath] = useUniversalHeader({
    variant: 'national',
    data: nationalHeaderData,
  })

  return (
    <Fragment>
      {isEvolved ? <Header /> : <UnifiedHeader />}
      <PageLanding
        heading={metaData.title}
        dataTestId="page-title"
        logo={undefined}
      >
        <Card className={style.card}>
          <TableOfContents sections={termsModules} />
          {termsModules.map(module => (
            <section key={module.slug} className={style.section}>
              <Heading type="large" id={module.slug} className={style.heading}>
                {module.title}
              </Heading>
              <Markdown content={module.bodyCopy} key={module.slug} />
            </section>
          ))}
        </Card>
      </PageLanding>
      {isEvolved ? (
        <UniversalFooter
          Link={Link}
          country={country}
          onFindACentre={() => setHeaderNavigationPath(['find-a-centre'])}
        />
      ) : (
        <NationalFooter />
      )}
    </Fragment>
  )
}

const getMetaData = ({
  metaData,
  staticContext,
}: RouteComponentProps & ContentPageProps): MetaData => {
  const COUNTRY = getCountry(staticContext)
  return {
    title: titleFromContentPage(COUNTRY, metaData),
    description: metaData.shortDescription,
  }
}

export default withCentreSelector(
  withGiftCards(
    withNationalHomepage(
      withContentPage(pagesHoc(ContentPage, getMetaData))
    ) as any
  ) as any
)
